import React from "react";
import { withNamespaces } from "react-i18next";
import {
  Card,
  Avatar,
  CardHeader,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import DefaultAvatar from "~/assets/img/avatar/avatar-default.png";
import { format } from "date-fns";
import { ptBR, es, enUS } from "date-fns/locale";

const BirthDayCard = ({ person, index, localeLanguage, t }) => {
  const getLocale = (locale) => {
    switch (locale) {
      case "pt":
        return ptBR;
      case "es":
        return es;
      case "en":
      default:
        return enUS;
    }
  };

  const formattedDate = person.data_nascimento
    ? format(new Date(person.data_nascimento), "dd MMMM", {
        locale: getLocale(localeLanguage),
      })
    : "";

  return (
    <Card
      key={index}
      sx={{
        marginBottom: "1rem",
        boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
        textAlign: "center",
        padding: "1rem",
        gap: "0.3rem",
      }}
    >
      <Box display="flex" flexDirection="column" alignItems="center" sx={{ gap: "0.5rem" }}>
        <Avatar
          aria-label="recipe"
          variant="square"
          src={person.foto ? person.foto : DefaultAvatar}
          sx={{
            width: "100px",
            height: "auto",
            marginRight: "0.5rem",
            objectFit: "contain",
          }}
        />
        <Typography variant="body2">{person.nome}</Typography>
        <Typography variant="body2" color="text.secondary">
          {formattedDate}
        </Typography>
      </Box>
    </Card>
  );
};

export default withNamespaces()(BirthDayCard);
